export function localisationReducer(state = {
    PARENT: {},
    CHILD: {},
    NAMES: {}, // list of all localisations with info
    ALL:{}, // show in selects
    LIST:{}, // display localisations List
},{
    type,
    payload
}){
    
    switch(type){
        
        case "NEW_LOCALISATION":     
        case "UPDATE_LOCALISATION":     
            let list = Object.assign({}, state);
            if(payload.is_parent){
                list.NAMES[payload.loc_id] = payload
                list.PARENT[payload.loc_id] = payload
            } else {
                list.CHILD[payload.loc_id] = payload
                
                if(list.ALL[payload.loc_parent]){
                    list.ALL[payload.loc_parent].push(payload.loc_id)
                    
                } else {
                    list.ALL[payload.loc_parent] = [payload.loc_id]
                }
            }
            return list

        case "REFETCH_LOCALISATIONS":

            return payload

        case "GET_PARENT_LOCALISATIONS":
            let list2 = Object.assign({}, state);
            list2.PARENT = payload
            list2.NAMES = Object.assign(list2.NAMES, payload)
            return list2
            
        case "GET_CHILD_LOCALISATIONS":
            let list3 = Object.assign({}, state);
            list3.CHILD = payload
            list3.NAMES = Object.assign(list3.NAMES, payload)
            Object.values(payload).forEach( cat => {
                if(!cat.loc_sub_parent){

                    if(list3.LIST[cat.loc_parent]){
                        list3.LIST[cat.loc_parent].push(cat.loc_id)
                        
                    } else {
                        list3.LIST[cat.loc_parent] = [cat.loc_id]
                    }
                } else {

                    if(list3.LIST[cat.loc_sub_parent]){
                        list3.LIST[cat.loc_sub_parent].push(cat.loc_id)
                    } else {
                        list3.LIST[cat.loc_sub_parent] = [cat.loc_id]
    
                    }
                }

                if(list3.ALL[cat.loc_parent]){
                    list3.ALL[cat.loc_parent].push(cat.loc_id)
                    
                } else {
                    list3.ALL[cat.loc_parent] = [cat.loc_id]
                }
            })
            return list3
        
        default:
            return state;
    }
    
}